import Vue from 'vue'
import Vuex from 'vuex'
/*global firebase*/

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userToken: null,
        user: null,
        drawer: null,
        noidContext: null,
        natOrgs: null,
        competitions: null,
        cScores: {},
        noLicenses: {},
        noCompetitions: {}
    },
    getters: {
        isAdmin: state => {
            if (state.userToken) {
                return !!state.userToken.claims.admin
            }
            return false
        },
        isNorgAdmin: state => {
            if (state.userToken) {
                return !!state.userToken.claims.norgadmin
            }
            return false
        },
        noidContext: state => {
            return state.noidContext
        },
        isLoggedIn: state => {
            return !!state.user
        },
        userMeta: state => {
            return state.user
        },
        drawer: state => {
            return state.drawer
        },
        natOrgs: state => {
            return state.natOrgs
        },
        competitions: state => {
            return state.competitions
        },
        licensesByNo: state => noid => state.noLicenses[noid],
        competitionByNo: state => noid => state.noCompetitions[noid],
        scoresByCid: state => cid => state.cScores[cid]
    },
    actions: {
        initUser: context => {
            firebase.auth().onAuthStateChanged(user => {
                context.commit('setUser', user)
                if (user) {
                    firebase
                        .auth()
                        .currentUser.getIdTokenResult()
                        .then(idTokenResult => {
                            // Confirm the user is an Admin.
                            context.commit('setUserToken', idTokenResult)
                            context.dispatch('initCompetitions')
                        })
                        .catch(error => {
                            console.log(error);
                            context.commit('setUserToken', null)
                            context.dispatch('initCompetitions')
                        });

                } else {
                    context.commit('setUserToken', null)
                    context.dispatch('initCompetitions')
                }
            });
        },
        initNatOrgs: context => {
            let natOrgsDbRef = firebase.database().ref("natorgs");
            natOrgsDbRef.on("value", snapshot => {
                context.commit("setNatOrgs", snapshot.val());
            });
        },
        initNatOrg: (context, noid) => {
            context.dispatch('initNatOrgTokens', noid)
            context.dispatch('initNatOrgCompetitions', noid)

            let natOrgsDbRef = firebase.database().ref("natorgs/" + noid);
            natOrgsDbRef.on("value", snapshot => {
                context.commit("setNatOrg", { noid: noid, val: snapshot.val() });
            });
        },
        initNatOrgTokens: (context, noid) => {
            let dbRef = firebase.database().ref("licenseinvites/" + noid)
            dbRef.on("value", snapshot => {
                context.commit("setNatOrgLicenses", { noid: noid, val: snapshot.val() });
            });
        },
        initNatOrgCompetitions: (context, noid) => {
            let dbRef = firebase.database().ref("nocompetitions/" + noid)
            dbRef.on("value", snapshot => {
                let comps = snapshot.val()
                context.commit("setNatOrgCompetitions", { noid: noid, val: comps });
                if (context.state.userToken.claims.norgadmin && !context.state.userToken.claims.admin) {
                    let compMap = Object.values(comps)
                    let compList = Object.values(compMap)
                    if (compList) {
                        for (let i = 0; i < compList.length; i++) {
                            firebase.database().ref("competitions/" + compList[i])
                                .on("value", snapshot => {
                                    context.commit("setCompetition", snapshot);
                                });
                        }
                    }
                }
            });
        },
        competitionScores: (context, cid) => {
            let comp = context.state.competitions[cid]
            if (comp.isAscending) {
                // by time
                firebase.database().ref('competitionscores/' + cid).orderByChild('time').on("value", snapshot => {
                    console.log('got scores: ')
                    console.log(snapshot.val());
                    context.commit("setCompetitionScores", { cid: cid, scores: Object.values(snapshot.val()) });
                });
            } else {
                // by score
                firebase.database().ref('competitionscores/' + cid).orderByChild('score').limitToLast(100).on("value", snapshot => {
                    console.log('got scores: ')
                    console.log(snapshot.val());
                    context.commit("setCompetitionScores", { cid: cid, scores: Object.values(snapshot.val()) });
                });
            }
        },
        initCompetitions: context => {
            let found = false
            if (context.state.userToken) {
                if (context.state.userToken.claims.admin) {
                    let competitionsDbRef = firebase.database().ref("competitions");
                    competitionsDbRef.on("value", snapshot => {
                        context.commit("setCompetitions", snapshot.val());
                    });
                    found = true
                } else if (context.state.userToken.claims.norgadmin) {
                    //TODO: retrieve only competitions for this NO context
                    firebase.database().ref("natorgs").orderByChild("email").equalTo(context.state.user.email).on("child_added", (snapshot) => {
                        context.commit("setNoidContext", snapshot.key)
                        context.dispatch('initNatOrg', snapshot.key)
                    });
                    console.log('NO competitions')
                    found = true
                }
            }
            if (!found) {
                firebase.database().ref(`usercompetitions/${context.state.user.uid}`).on("value", snapshot => {
                    let compList = Object.values(snapshot.val())
                    if (compList) {
                        for (let i = 0; i < compList.length; i++) {
                            firebase.database().ref("competitions/" + compList[i])
                                .on("value", snapshot => {
                                    context.commit("setCompetition", snapshot);
                                });
                        }
                    }
                });
            }
        }
    },
    mutations: {
        setUserToken(state, userToken) {
            state.userToken = userToken
        },
        setUser(state, user) {
            state.user = user
        },
        setDrawer(state, drawer) {
            state.drawer = drawer
        },
        setNatOrgs(state, orgs) {
            state.natOrgs = orgs
        },
        setNoidContext(state, noid) {
            state.noidContext = noid
        },
        setNatOrg(state, payload) {
            if (!state.natOrgs) {
                state.natOrgs = {}
            }
            Vue.set(state.natOrgs, payload.noid, payload.val)
        },
        setNatOrgLicenses(state, payload) {
            Vue.set(state.noLicenses, payload.noid, payload.val)
        },
        setNatOrgCompetitions(state, payload) {
            Vue.set(state.noCompetitions, payload.noid, payload.val)
        },
        setCompetitions(state, competitions) {
            state.competitions = competitions
        },
        setCompetition(state, snapshot) {
            if (!state.competitions) {
                state.competitions = {}
            }
            Vue.set(state.competitions, snapshot.key, snapshot.val())
        },
        setCompetitionScores(state, payload) {
            let comp = state.competitions[payload.cid]
            if (comp.isAscending) {
                Vue.set(state.cScores, payload.cid, payload.scores)
            } else {
                Vue.set(state.cScores, payload.cid, payload.scores.reverse())
            }
        }
    }
})